import { Link } from "react-router-dom";
import { Button, Container, Nav, Navbar, NavbarBrand, NavItem, NavLink } from "reactstrap";
import BonusPoints from "../../../components/bonifiedInteractions/BonusPoints";
import keycloak from "../../../keycloak";
import { isLoggedIn } from "../../../store/actions/LoginActions";
import { UrlPathBonifiedInteractions, UrlPathMain } from "../../../url";
import { SelectTheme } from "../../SwitchTheme";
import logo from "../images/hagebaumarkt.png";

export const Header = () => {
  const logoutAndRedirect = () => {
    keycloak.logout();
  };
  return (
    <header>
      <Container style={{ paddingLeft: 0, paddingBottom: 16 }}>
        <Navbar expand="xs">
          <NavbarBrand tag={isLoggedIn() ? Link : undefined} to={isLoggedIn() ? UrlPathMain : undefined}>
            <img src={logo} style={{}} alt="Hagebaumarkt" />
          </NavbarBrand>
          <Nav className="ml-auto" navbar>
            {isLoggedIn() && (
              <>
                <NavItem>
                  <NavLink tag={Link} to={UrlPathBonifiedInteractions} style={{ textAlign: "center" }}>
                    <div
                      style={{
                        marginTop: "4px",
                        fontSize: 24,
                        marginBottom: "-2px",
                      }}
                    >
                      <b>
                        <BonusPoints />
                      </b>
                    </div>
                    <span style={{ color: "black" }}>Deine Punkte</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <Button color="link" onClick={logoutAndRedirect}>
                    <i
                      className="bi-person"
                      style={{
                        fontSize: 34,
                        lineHeight: 0,
                        padding: 0,
                        color: "black",
                        marginLeft: 10,
                      }}
                    />
                    <br />
                    <span style={{ color: "black" }}>Logout</span>
                  </Button>
                </NavItem>
              </>
            )}
            <NavItem>
              <SelectTheme />
            </NavItem>
          </Nav>
        </Navbar>
      </Container>
    </header>
  );
};
